export default "/assets/images/graph-pollen.f7f51a37e6eab281.png";